import "react";
import o from "./index148.mjs";
import c from "./index648.mjs";
import { j as n } from "./index58.mjs";
import { C as p } from "./index441.mjs";
let e;
typeof document == "object" && (e = c({
  key: "css",
  prepend: !0
}));
function s(t) {
  const {
    injectFirst: i,
    children: r
  } = t;
  return i && e ? /* @__PURE__ */ n.jsx(p, {
    value: e,
    children: r
  }) : r;
}
process.env.NODE_ENV !== "production" && (s.propTypes = {
  /**
   * Your component tree.
   */
  children: o.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: o.bool
});
export {
  s as default
};
